/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityDomainBlocklistAgg } from './ControlEntityDomainBlocklistAgg';
import {
    ControlEntityDomainBlocklistAggFromJSON,
    ControlEntityDomainBlocklistAggFromJSONTyped,
    ControlEntityDomainBlocklistAggToJSON,
} from './ControlEntityDomainBlocklistAgg';

/**
 * 
 * @export
 * @interface ControlEntityDomainsBlocklistsAggResponse
 */
export interface ControlEntityDomainsBlocklistsAggResponse {
    /**
     * 
     * @type {Array<ControlEntityDomainBlocklistAgg>}
     * @memberof ControlEntityDomainsBlocklistsAggResponse
     */
    results?: Array<ControlEntityDomainBlocklistAgg>;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDomainsBlocklistsAggResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDomainsBlocklistsAggResponse
     */
    assets?: number;
}

/**
 * Check if a given object implements the ControlEntityDomainsBlocklistsAggResponse interface.
 */
export function instanceOfControlEntityDomainsBlocklistsAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityDomainsBlocklistsAggResponseFromJSON(json: any): ControlEntityDomainsBlocklistsAggResponse {
    return ControlEntityDomainsBlocklistsAggResponseFromJSONTyped(json, false);
}

export function ControlEntityDomainsBlocklistsAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDomainsBlocklistsAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityDomainBlocklistAggFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
    };
}

export function ControlEntityDomainsBlocklistsAggResponseToJSON(value?: ControlEntityDomainsBlocklistsAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityDomainBlocklistAggToJSON)),
        'total': value.total,
        'assets': value.assets,
    };
}

